import api from '@edu-fe/api'

export default {
  name: 'utils',

  url2base64 (url) {
    return api.create(`/image/base64?url=${url}`)
  },

  pop: api.create('/pop')
}
